let accessToken: string | null = null;
let accessTokenPromise: Promise<string | null> | null = null;

export const setAccessToken = (token: string | null) => {
    accessToken = token;
};

export const getStoredAccessToken = () => accessToken;

export const setAccessTokenPromise = (promise: Promise<string | null>) => {
    accessTokenPromise = promise;
};

export const getAccessTokenAsync = async (): Promise<string | null> => {
    if (accessToken) {
        return accessToken;
    }

    if (!accessTokenPromise) {
        return null;
    }

    const token = await accessTokenPromise;

    if (token) {
        accessToken = token;
    }

    return token;
};
